import { Flex } from "antd";
import { ItemInfo } from "components";
import { COMPANY_TYPE_LABELS, COMPANY_TYPES, CompanyEntity } from "interfaces";
import { observer } from "mobx-react-lite";
import { getPhone, dateFormat, getShortName } from "utils";

export const IpInfo = observer(({ companyCard }: { companyCard: CompanyEntity }) => {
  const fullName =
    companyCard.surname && companyCard.name
      ? getShortName(companyCard.surname ?? "", companyCard.name ?? "", companyCard.patronymic ?? "")
      : "—";

  return (
    <Flex vertical>
      <ItemInfo title="Тип" text={COMPANY_TYPE_LABELS[COMPANY_TYPES.IP]} vertical={false} />
      <ItemInfo title="ФИО" text={fullName} vertical={false} />
      <ItemInfo title="Дата рождения" text={dateFormat(companyCard.birthDate ?? "") ?? "—"} vertical={false} />
      <ItemInfo title="Серия паспорта" text={companyCard.identificationDocSeria ?? "—"} vertical={false} />
      <ItemInfo title="Номер паспорта" text={companyCard.identificationDocNumber ?? "—"} vertical={false} />
      <ItemInfo title="Кем выдан" text={companyCard.identificationDocIssuer ?? "—"} vertical={false} />
      <ItemInfo
        title="Дата выдачи"
        text={dateFormat(companyCard.identificationDocIssueDate ?? "") ?? "—"}
        vertical={false}
      />
      <ItemInfo title="Почтовый адрес" text={companyCard.postAddress ?? "—"} vertical={false} />
      <ItemInfo title="Код подразделения" text={companyCard.identificationDocIssuerCode ?? "—"} vertical={false} />
      <ItemInfo title="ОГРНИП" text={companyCard.companyRegistrationNumber ?? "—"} vertical={false} />
      <ItemInfo title="ИНН" text={companyCard.inn ?? "—"} vertical={false} />
      <ItemInfo title="Телефон" text={getPhone(companyCard.phone ?? "") || "—"} vertical={false} />
      <ItemInfo title="Email" text={companyCard.email ?? "—"} vertical={false} />
      <ItemInfo title="Налоговый резидент РФ" text={companyCard.isOnlyTaxResidentRF ? "Да" : "Нет"} vertical={false} />
      <ItemInfo
        title="Дата заключения договора"
        text={dateFormat(companyCard.contractDate ?? "") ?? "—"}
        vertical={false}
      />
      <ItemInfo title="Номер договора-основания" text={companyCard.contractNumber ?? "—"} vertical={false} />
    </Flex>
  );
});
